import React from 'react';
import Wrapper from './Wrapper';

function ProductsModal({ onClose, setProducts }) {
  return <Wrapper onClose={onClose} setProducts={setProducts} />;
}

export default ProductsModal;
